import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { css } from "@emotion/react";
import { MUTATION_TYPE, useToast } from "hooks";
import { GENERATE_MISSION_ROLE_TEMPLATE } from "graphql/mutations";
import { GET_MISSION_ROLE_TEMPLATES } from "graphql/queries";
import { ModalForm } from "components/Modal";
import { SIZE, TYPE } from "components/Form";

/**
 * BlueprintGenerateModal
 *
 * Starts the blueprint generation agent for a profession; the new blueprint fills in from the blueprints list.
 *
 * @param {Boolean}   show
 * @param {Function}  onClose
 */
const BlueprintGenerateModal = ({ show, onClose, ...props }) => {
  const intl = useIntl();
  const { toast } = useToast();

  const handleCompleted = () => {
    onClose();
    toast.success(<FormattedMessage id="Blueprints.GenerateModal.Success" />);
  };

  const handleError = () => toast.error(<FormattedMessage id="Blueprints.GenerateModal.Error" />);

  return (
    <ModalForm
      title={<FormattedMessage id="Blueprints.GenerateModal.Title" />}
      description={<FormattedMessage id="Blueprints.GenerateModal.Description" />}
      show={show}
      onClose={onClose}
      data={COLUMN_DATA(intl)}
      initialValues={{}}
      mutationType={MUTATION_TYPE.add}
      mutationData={{
        mutationName: { add: GENERATE_MISSION_ROLE_TEMPLATE },
        refetchAfterMutate: true,
        refetchQueries: [GET_MISSION_ROLE_TEMPLATES],
      }}
      primaryButtonMessageId="Blueprints.GenerateModal.Submit"
      onCompleted={handleCompleted}
      onError={handleError}
      {...props}
    />
  );
};

const COLUMN_DATA = (intl) => [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        label: <FormattedMessage id="Blueprints.GenerateModal.Profession" />,
        type: TYPE.input,
        size: SIZE.xlarge,
        properties: {
          name: "profession",
          type: "text",
          required: true,
          autoFocus: true,
          maxLength: 100,
          placeholder: intl.formatMessage({ id: "Blueprints.GenerateModal.ProfessionPlaceholder" }),
        },
      },
      {
        label: <FormattedMessage id="Blueprints.GenerateModal.Name" />,
        type: TYPE.input,
        size: SIZE.xlarge,
        properties: {
          name: "name",
          type: "text",
          required: false,
          maxLength: 100,
          placeholder: intl.formatMessage({ id: "Blueprints.GenerateModal.NamePlaceholder" }),
        },
      },
    ],
  },
];

BlueprintGenerateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default BlueprintGenerateModal;
